var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17082_34808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75714 1.07717C4.91338 0.920883 5.12531 0.833055 5.3463 0.833008H8.33464C8.55565 0.833008 8.76761 0.920805 8.92389 1.07709C9.08017 1.23337 9.16797 1.44533 9.16797 1.66634V4.65467C9.16792 4.87567 9.08009 5.0876 8.9238 5.24384L5.29714 8.87051C5.10775 9.05869 4.85162 9.16431 4.58464 9.16431C4.31765 9.16431 4.06152 9.05869 3.87214 8.87051L1.13047 6.12884C0.942283 5.93946 0.836662 5.68332 0.836662 5.41634C0.836662 5.14936 0.942283 4.89322 1.13047 4.70384L4.75714 1.07717Z",
    stroke: "#54FF99",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8737 3.33366C6.75864 3.33366 6.66536 3.24038 6.66536 3.12533C6.66536 3.01027 6.75864 2.91699 6.8737 2.91699C6.98876 2.91699 7.08203 3.01027 7.08203 3.12533C7.08203 3.24038 6.98876 3.33366 6.8737 3.33366Z",
    stroke: "#54FF99",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17082_34808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "matrix(-1 0 0 1 10 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.572523b49b67cc0ee040a59b592a2680.svg";
export { ForwardRef as ReactComponent };